import styled from "styled-components";
import { media } from "../../styles/breakpoints";

const FilterStyled = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;

  .filter {
    &__label {
      font-size: ${(props) => props.theme.fonts.textFontSizeM};
      font-weight: ${(props) => props.theme.fonts.fontWeightMedium};
      color: ${(props) => props.theme.colour.text.primary};
      margin-bottom: ${(props) => props.theme.spacing.sm};

      ${media.tablet`
        font-size: 1.5rem;
        margin-bottom: 0;
      `}
    }

    &__select {
      width: 100%;
      padding: ${(props) => props.theme.spacing.sm}
        ${(props) => props.theme.spacing.md};
      font-size: ${(props) => props.theme.fonts.textFontSizeM};
      font-weight: ${(props) => props.theme.fonts.fontWeightNormal};
      color: ${(props) => props.theme.colour.text.primary};
      background-color: ${(props) => props.theme.colour.background.primary};
      border: 2px solid ${(props) => props.theme.colour.border.medium};
      border-radius: ${(props) => props.theme.border.borderRadiusLarge};
      cursor: pointer;
      transition: ${(props) => props.theme.transitions.normal};
      min-height: 40px;
      appearance: none;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right ${(props) => props.theme.spacing.md} center;
      background-size: 16px;
      padding-right: ${(props) => props.theme.spacing.xl};

      ${media.tablet`
        width: 100%;
        font-size: 1.125rem;
        padding: 12px 20px;
        padding-right: 40px;
        background-size: 18px;
        min-height: 44px;
      `}

      ${media.desktop`
        font-size: 1.25rem;
        padding: 14px 24px;
        padding-right: 44px;
        background-size: 20px;
        min-height: 48px;
      `}

      ${media.wide`
        font-size: 1.375rem;
        padding: 16px 28px;
        padding-right: 48px;
        background-size: 22px;
        min-height: 52px;
      `}

      &:hover {
        border-color: ${(props) => props.theme.colour.border.focus};
        box-shadow: ${(props) => props.theme.shadows.xsmall};
      }

      &:focus {
        outline: none;
        border-color: ${(props) => props.theme.colour.border.focus};
        box-shadow: 0 0 0 3px rgba(74, 124, 89, 0.1);
      }

      &:disabled {
        background-color: ${(props) => props.theme.colour.background.tertiary};
        color: ${(props) => props.theme.colour.text.disabled};
        cursor: not-allowed;
        opacity: 0.6;
      }

      option {
        padding: ${(props) => props.theme.spacing.sm};
        font-size: ${(props) => props.theme.fonts.textFontSizeM};
      }
    }

    &__container {
      display: flex;
      flex-direction: column;
      gap: ${(props) => props.theme.spacing.sm};
      width: 100%;

      ${media.tablet`
        flex-direction: row;
        align-items: center;
        gap: 16px;
        width: 100%;
      `}
    }

    &__clear {
      background-color: ${(props) => props.theme.colour.semantic.error};
      color: ${(props) => props.theme.colour.text.inverse};
      border: none;
      border-radius: ${(props) => props.theme.border.borderRadiusSmall};
      padding: ${(props) => props.theme.spacing.sm}
        ${(props) => props.theme.spacing.md};
      font-size: ${(props) => props.theme.fonts.textFontSizeS};
      font-weight: ${(props) => props.theme.fonts.fontWeightMedium};
      cursor: pointer;
      transition: ${(props) => props.theme.transitions.normal};
      min-height: 44px;
      min-width: 44px;

      ${media.tablet`
        padding: 16px 24px;
        font-size: 1.25rem;
      `}

      &:hover:not(:disabled) {
        background-color: #c82333;
        transform: translateY(-1px);
        box-shadow: ${(props) => props.theme.shadows.small};
      }

      &:focus-visible {
        outline: 2px solid ${(props) => props.theme.colour.semantic.error};
        outline-offset: 2px;
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
      }
    }
  }

  /* Estilos para múltiples filtros */
  .filters-row {
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.spacing.md};

    ${media.tablet`
      flex-direction: row;
      align-items: center;
      gap: 24px;
    `}
  }
`;

export default FilterStyled;
